import * as React from 'react';

import Pusher from 'pusher-js';

// @ts-expect-error
let pusherInstance = null;

export function initializeAgentPresence(shouldForce = false) {
    if (
        (typeof NutClientConfig === 'undefined' || !NutClientConfig.shouldPollPresence) &&
        !shouldForce
    ) {
        return null;
    }

    // @ts-expect-error
    if (pusherInstance) {
        return pusherInstance;
    }

    const pusherConfig = NutClientConfig.pusherConfig;

    pusherInstance = new Pusher(pusherConfig.key, {
        cluster: pusherConfig.cluster,
        // @ts-expect-error
        channelAuthorization: {endpoint: '/pusher/auth'},
    });

    pusherInstance.subscribe(pusherConfig.agentPresenceChannel);

    return pusherInstance;
}

export function disconnectAgentPresence() {
    // @ts-expect-error
    if (pusherInstance) {
        pusherInstance.disconnect();
        pusherInstance = null;
    }
}

export function useAgentPresence() {
    React.useEffect(() => {
        const instance = initializeAgentPresence();

        return () => {
            if (instance) {
                disconnectAgentPresence();
            }
        };
    }, []);
}
